module.exports = __webpack_public_path__ + "img/trivia-error-player.32ba73db.svg";